<ngx-spinner bdColor="rgba(51,51,51,0.2)"
             class="spinner"
             color="#fff"
             size="large"
             type="ball-clip-rotate"></ngx-spinner>
<router-outlet></router-outlet>
